import { render, staticRenderFns } from "./CollectDetails.vue?vue&type=template&id=46a0fe10&scoped=true&"
import script from "./CollectDetails.vue?vue&type=script&lang=js&"
export * from "./CollectDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollectDetails.vue?vue&type=style&index=0&id=46a0fe10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0fe10",
  null
  
)

export default component.exports